import { Trans } from "react-i18next";

import { TabType } from "../../atoms";

export type TabsType = "CURRENT" | "PREVIOUS";

export const TABS_USER_SESSIONS: TabType<TabsType>[] = [
  {
    id: "CURRENT",
    label: (
      <Trans i18nKey="page.userMember.tab.userSessions.creditPacksList.tabs.current" />
    ),
  },
  {
    id: "PREVIOUS",
    label: (
      <Trans i18nKey="page.userMember.tab.userSessions.creditPacksList.tabs.previous" />
    ),
  },
];
